module.exports = __webpack_public_path__ + "7e235e8ce0c614fd32dfcbae49bc5888.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth0Animation/components/Step1/step-1-placeholder.png
// module id = 1564
// module chunks = 0